// extracted by mini-css-extract-plugin
export var header = "_w1-1";
export var maskBottom = "_w1-6";
export var maskMiddle = "_w1-7";
export var maskTop = "_w1-5";
export var root = "_w1-0";
export var scrollDownButton = "_w1-3";
export var scrollDownButtonHidden = "_w1-4";
export var viewport = "_w1-2";